// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__CM5BJ","dashCard":"Dashboard_dashCard__9jQ9l","card-button":"Dashboard_card-button__vueNv"};